module.exports = __webpack_public_path__ + "dash_20_app_assets/img/arrowright.68f538c3.png";